import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns whether the shared coprincipal account functionality is enabled.
 */
export function isSharedCoprincipalAccountEnabled(): boolean {
    return isFeatureEnabled('acct-sharedcpa', undefined, /*dontThrowErrorIfNotInitialized*/ true);
}
